import { createRoot } from "react-dom/client";

const registry = {};

export function register(components) {
  Object.assign(registry, components);
  mount();
}

function mount() {
  const contextElement = document.querySelector(".js-vite-rails-context");
  const railsContext = contextElement
    ? JSON.parse(contextElement.textContent)
    : {};

  document.querySelectorAll(".js-vite-component").forEach((element) => {
    const name = element.dataset.componentName;
    const domId = element.dataset.domId;
    const props = JSON.parse(element.textContent);
    const mountPoint = document.getElementById(domId);

    if (!mountPoint) {
      console.error(`vite-mount: No mount point found with id '${domId}'`);
      return;
    }

    const generator = registry[name];
    if (!generator) {
      console.error(
        `vite-mount: Component '${name}' not found in registry. ` +
          `Registered: [${Object.keys(registry).join(", ")}]`
      );
      return;
    }

    const root = createRoot(mountPoint);
    root.render(generator(props, railsContext));
  });
}
